import { Badge, Card, CardBody, Col } from "reactstrap";
import { SecondaryBorderState } from "../../../../Constant";
import { BORDER_SECONDARY, BORDER_SECONDARY_LIST } from "../../../../Data/Bonus Ui/CreativeCard";
import CommonCreativeCardHeader from "../Common/CommonCreativeCardHeader";
import { LI, OL } from "../../../../AbstractElements";

const BorderSecondaryState = () => {
  return (
    <Col xxl="4" sm="12">
      <Card className="height-equal">
        <CommonCreativeCardHeader headerClass="border-l-secondary border-3" title={SecondaryBorderState} span={BORDER_SECONDARY} />
        <CardBody className="scroll-demo">
          <OL className="list-group list-group-numbered scroll-rtl">
            <LI className="d-flex align-items-start flex-wrap">
              <div className="ms-2 me-auto">Stella Nowland</div>
              <Badge color="warning" pill className="p-2">Freelance</Badge>
            </LI>
            {BORDER_SECONDARY_LIST.map(({title,color,tag}, index) => (
              <LI className="d-flex align-items-start flex-wrap" key={index}>
                <div className="ms-2 me-auto">{title}</div>
                <Badge color={color} pill className="p-2">{tag}</Badge>
              </LI>
            ))}
          </OL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BorderSecondaryState;
